var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Image", attrs: { url: _vm.getUrl } },
    [
      _vm.showImage
        ? _c(
            "viewer",
            { attrs: { images: _vm.urlArr } },
            _vm._l(_vm.urlArr, function (src) {
              return _c("img", {
                key: src,
                staticClass: "avatar-url",
                attrs: { src: src, alt: "" },
              })
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }